<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>Modificar posición del </strong> nodo {{LOCAL_DATA.nombre}} a {{destino.nombre}} ?</h1>
<div mat-dialog-content fxLayout="column">
</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
